import React, { ComponentType } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import {
  SplashScreen,
  withTranslation,
} from '@piwikpro/ui-components';
import { errorBoundary, withAccess, withInject } from '@piwikpro/platform';
import { IFeatureFlags } from '@piwikpro/feature-flags-crate';
import { TFunction } from 'react-i18next';
import { STATE_ROOT, AdministrationState } from '../../../../redux';

const mapStateToProps = (state: AdministrationState & {
  featureFlags: IFeatureFlags
}) => {
  const app = state[STATE_ROOT].apps.details.settings.settings;

  return {
    app: app as NonNullable<typeof app>,
    featureFlags: state.featureFlags,
  };
};

const connector = connect(mapStateToProps);

type ReduxProps = ConnectedProps<typeof connector>;

interface InjectedProps {
  t: TFunction
  Title: any
  Integrations: ComponentType<any>
  accessManager: { isGranted: (context: { role: string }) => boolean }
  match?: any
}

type SingleDigitalGatewayProps = InjectedProps & ReduxProps;

const SingleDigitalGateway: React.FunctionComponent<SingleDigitalGatewayProps> = ({
  t,
  Title,
  Integrations,
  match,
  accessManager,
  app,
  featureFlags,
}) => {
  const isOwner = accessManager.isGranted({ role: 'OWNER' });
  const isDemoApp = app?.attributes.appType === 'demo';
  const sdgAvailable = featureFlags?.sdgIntegration;

  if (isDemoApp || !sdgAvailable) {
    return null;
  }

  if (!isOwner) {
    return <SplashScreen type="noPrivileges" />;
  }

  return (
    <Title part={t('apps.details.tabs.sdg')}>
      <Integrations match={match} />
    </Title>
  );
};

export default connector(withInject({
  Title: 'TitleCrate.components.Title',
  Integrations: 'SingleDigitalGatewayCrate.components.Integrations',
})(
  withAccess(withTranslation(['administration'])(errorBoundary(SingleDigitalGateway))),
));
